function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import './svg.scss';
import CustomHTMLElement from 'html-element';
import { sendRequest } from 'js-api'; // There is a chrome bug which means that not doing this can block rendering for a significant period of time.

var spritesPreloaded = false;
var preloadedSprite = null;
export function preloadSprites() {
  return _preloadSprites.apply(this, arguments);
}

function _preloadSprites() {
  _preloadSprites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (window.config.spriteUrl) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            spritesPreloaded = true;

            if (preloadedSprite) {
              _context.next = 10;
              break;
            }

            _context.next = 6;
            return sendRequest('GET', window.config.spriteUrl);

          case 6:
            response = _context.sent;
            preloadedSprite = document.createElement('div');
            preloadedSprite.style.display = 'none';
            preloadedSprite.innerHTML = response.content;

          case 10:
            if (!document.body) {
              window.addEventListener('DOMContentLoaded', function () {
                return document.body.appendChild(preloadedSprite);
              });
            } else {
              document.body.appendChild(preloadedSprite);
            }

            document.addEventListener('turboujs:load', function (_event) {
              document.body.appendChild(preloadedSprite);
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _preloadSprites.apply(this, arguments);
}

var SpriteSvg = /*#__PURE__*/function (_CustomHTMLElement) {
  _inherits(SpriteSvg, _CustomHTMLElement);

  var _super = _createSuper(SpriteSvg);

  function SpriteSvg() {
    _classCallCheck(this, SpriteSvg);

    return _super.apply(this, arguments);
  }

  _createClass(SpriteSvg, [{
    key: "_runSetup",
    value: function _runSetup() {
      this.updateIcon();
    }
  }, {
    key: "iconName",
    get: function get() {
      return this.getAttribute('name');
    },
    set: function set(value) {
      if (value === null) {
        value = '';
      }

      this.setAttribute('name', value);
      this.updateIcon();
    }
  }, {
    key: "updateIcon",
    value: function updateIcon() {
      var name = this.iconName;

      if (name === '' || name === null) {
        this.innerHTML = '';
        return;
      }

      var colored = this.getBooleanAttribute('colored');
      var spriteName = "sprite-".concat(name);

      if (colored) {
        spriteName += '--colored';
      }

      if (spritesPreloaded) {
        this.innerHTML = "<svg><use xlink:href=\"#".concat(spriteName, "\"></use></svg>");
      } else {
        var spritemap = window.config.spriteUrl;
        this.innerHTML = "<svg><use xlink:href=\"".concat(spritemap, "#").concat(spriteName, "\"></use></svg>");
      }
    }
  }]);

  return SpriteSvg;
}(CustomHTMLElement);

export { SpriteSvg as default };
window.customElements.define('sprite-svg', SpriteSvg);